import { render } from "./MonsterAttacks.vue?vue&type=template&id=d38fcd40&scoped=true"
import script from "./MonsterAttacks.vue?vue&type=script&lang=js"
export * from "./MonsterAttacks.vue?vue&type=script&lang=js"

import "./MonsterAttacks.vue?vue&type=style&index=0&id=d38fcd40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d38fcd40"]])

export default __exports__